/**
 * 埋点文档：https://z9ejadizza.feishu.cn/sheets/shtcnA6yW8QRqhvQZguK65GHv5q?sheet=RblEC5
 */

import { pagePvType, zhugAddWorkerType, zhugeExportType } from '@/type'

// 发送诸葛埋点主方法
function sendZhuge(eventName: string, props = {} as any) {
  try {
    window.zhuge.track(eventName, props) // 事件名称不能超过20个字符
  } catch (error) {
    console.log('ZHUGE_TRACH_ERROR', error)
  }
}

/**
 * word开头：word内埋点
 * excel开头：excel内埋点
 * doc开头：整个项目通用埋点
 */
export default {
  // 初始化诸葛埋点用户
  identify(oa: string, pointJson: any) {
    window.zhuge.identify(oa, pointJson)
  },

  // 设置全局埋点属性
  setGlobalZhuge(data: any) {
    window.zhuge.setSuperProperty(data)
  },

  page_pv(options: pagePvType) {
    sendZhuge('页面PV', options)
  },

  doc_no_support() {
    sendZhuge('不支持的浏览器提示界面pv次数')
  },
  word_add(fildId: string) {
    sendZhuge('新建文档-加号', {
      文档ID: fildId
    })
  },
  excel_add(fildId: string) {
    sendZhuge('新建表格-加号', {
      文档ID: fildId
    })
  },
  word_add_button(fildId: string) {
    sendZhuge('新建文档-协同文档首页', {
      文档ID: fildId
    })
  },
  excel_add_button(fildId: string) {
    sendZhuge('新建表格-协同文档首页', {
      文档ID: fildId
    })
  },
  word_export_word(options: zhugeExportType) {
    sendZhuge('导出为Word', options)
  },
  word_export_pdf(options: zhugeExportType) {
    sendZhuge('导出为PDF', options)
  },
  word_export_excel(options: any) {
    sendZhuge('导出为Excel', options)
  },
  excel_export(options: any) {
    sendZhuge('导出为Excel', options)
  },
  word_add_worker(options: zhugAddWorkerType) {
    sendZhuge('Word-网页端-添加协作者', options)
  },
  excel_add_worker(options: zhugAddWorkerType) {
    sendZhuge('Excel-网页端-添加协作者', options)
  },
  word_preview() {
    sendZhuge('演示文档')
  },
  word_restore() {
    sendZhuge('Word-还原版本')
  },
  excel_restore() {
    sendZhuge('Excel-还原版本')
  },
  word_self_save() {
    sendZhuge('Word手动保存版本')
  },
  excel_self_save() {
    sendZhuge('Excel手动保存版本')
  },
  word_offline() {
    sendZhuge('Word-编辑器断连提示')
  },
  excel_other_edit() {
    sendZhuge('Excel-编辑冲突提示')
  },
  excel_offline() {
    sendZhuge('Excel-编辑器断连提示')
  },
  importFile(options: any) {
    sendZhuge('导入为协同文档', options)
  },
  importExcel(options: any) {
    sendZhuge('导入为协同表格', options)
  },
  addCommentWord(options: any) {
    sendZhuge('网页-Word-添加批注', options)
  },
  addCommentExcel(options: any) {
    sendZhuge('网页-Excel-添加批注', options)
  },
  replyWord(options: any) {
    sendZhuge('网页-Word-回复批注', options)
  },
  replyExcel(options: any) {
    sendZhuge('网页-Excel-回复批注', options)
  },
  mentionUser(options: any) {
    sendZhuge('网页端-Word-提及同事', options)
  },
  revoke(options: any) {
    sendZhuge('撤销通知', options)
  },
  wordLock(options: any) {
    sendZhuge('Word-锁定', options)
  },
  wordCreateCopy(options: any) {
    sendZhuge('Word-创建副本', options)
  },
  excelCreateCopy(options: any) {
    sendZhuge('Excel-创建副本', options)
  },
  excelInvalid(options: any) {
    sendZhuge('Excel-无效操作', options)
  },
  wordPpt(options: any) {
    sendZhuge('Word-分页幻灯片演示', options)
  },
  wordCheckHistory(options: any) {
    sendZhuge('Word-查看历史信息', options)
  },
  excelCheckHistory(options: any) {
    sendZhuge('Excel-查看历史信息', options)
  },
  wordDelete(options: any) {
    sendZhuge('Word-删除文档', options)
  },
  excelDelete(options: any) {
    sendZhuge('Excel-删除文档', options)
  },
  wordTarbar(options: any) {
    sendZhuge('Word工具栏操作', options)
  },
  excelTarbar(options: any) {
    sendZhuge('Excel工具栏操作', options)
  },
  continueList(options: any) {
    sendZhuge('有序列表-继续之前的编号', options)
  },
  restartList(options: any) {
    sendZhuge('有序列表-开始新编号', options)
  },
  changeList(options: any) {
    sendZhuge('有序列表-修改编号值', options)
  },
  wordTableAddRow(options: any) {
    sendZhuge('Word-表格操作-新增行', options)
  },
  wordTableAddCol(options: any) {
    sendZhuge('Word-表格操作-新增列', options)
  },
  wordTableRemoveRow(options: any) {
    sendZhuge('Word-表格操作-删除行', options)
  },
  wordTableRemoveCol(options: any) {
    sendZhuge('Word-表格操作-删除列', options)
  },
  wordTableMergeCell(options: any) {
    sendZhuge('Word-表格操作-合并单元格', options)
  },
  wordTableSplitCell(options: any) {
    sendZhuge('Word-表格操作-拆分单元格', options)
  },
  noWord(options: any) {
    sendZhuge('文档不存在PV', options)
  },
  wordRemove(options: any) {
    sendZhuge('文档已被删除页面PV', options)
  },
  wordLocalFile200(options: any) {
    sendZhuge('Word-插入的本地文档超出200M提示', options)
  },
  wordLocalImg30(options: any) {
    sendZhuge('Word-插入的图片超出30M提示', options)
  },
  wordNotAllowedFile(options: any) {
    sendZhuge('Word-插入的文件格式不支持', options)
  },
  wordNoAuth(options: any) {
    sendZhuge('无权限页面', options)
  },
  wordNoAuthRequest(options: any) {
    sendZhuge('无权限用户申请权限', options)
  },
  requestEditAuth(options: any) {
    sendZhuge('阅读权限用户申请编辑权限', options)
  },
  requestAuthApply(options: any) {
    sendZhuge('网页端-收到权限申请进行授权', options)
  },
  allowAuth(options: any) {
    sendZhuge('Word-@人没权限直接赋权', options)
  },
  noAllowAuth(options: any) {
    sendZhuge('Word-@人没权限不赋权', options)
  },
  excelAddSheet(options: any) {
    sendZhuge('Excel-新建sheet页', options)
  },
  excelCopySheet(options: any) {
    sendZhuge('Excel-复制工作表', options)
  },
  excelRenameSheet(options: any) {
    sendZhuge('Excel-重命名工作表', options)
  },
  excelHideLine(options: any) {
    sendZhuge('Excel-隐藏网格线', options)
  },
  excelShowLine(options: any) {
    sendZhuge('Excel-显示网格线', options)
  },
  excelCopy(options: any) {
    sendZhuge('Excel-复制', options)
  },
  excelPaste(options: any) {
    sendZhuge('Excel-粘贴', options)
  },
  excelPasteFaild(options: any) {
    sendZhuge('Excel-粘贴超限失败', options)
  },
  excelCut(options: any) {
    sendZhuge('Excel-剪切', options)
  },
  excelPasteValue(options: any) {
    sendZhuge('右键-仅粘贴值', options)
  },
  excelPasteTransform(options: any) {
    sendZhuge('右键-转置粘贴', options)
  },
  excelHiddenRows(options: any) {
    sendZhuge('右键-隐藏行', options)
  },
  excelHiddenCols(options: any) {
    sendZhuge('右键-隐藏列', options)
  },
  excelRecoverRows(options: any) {
    sendZhuge('取消隐藏行-图标', options)
  },
  excelRecoverCols(options: any) {
    sendZhuge('取消隐藏列-图标', options)
  },
  excelRecoverRowsRight(options: any) {
    sendZhuge('取消隐藏行-右键', options)
  },
  excelRecoverColsRight(options: any) {
    sendZhuge('取消隐藏列-右键', options)
  },
  wordOpenLinkShare(options: any) {
    sendZhuge('网页端-Word-开启链接分享', options)
  },
  excelOpenLinkShare(options: any) {
    sendZhuge('网页端-Excel-开启链接分享', options)
  },
  pasteImgFail(options: any) {
    sendZhuge('Word-复制图文时，提示图片复制不成功', options)
  },
  wordInsertFileOverWeight() {
    sendZhuge('Word-插入的本地文档超出200M提示')
  },
  wordInsertImgOverWeight() {
    sendZhuge('Word-插入的图片超出30M提示')
  },
  wordInsertImgNotSupport() {
    sendZhuge('Word-插入的图片格式不支持')
  },
  pushTaskSuccess() {
    sendZhuge('任务发送成功')
  }
}
